<div
  class="fixed inset-0 z-app-overlay-0 flex flex-col bg-(--p-other-opacity-white-80) backdrop-blur-[2.5rem]"
  [ngClass]="styleClass()">
  <header class="flex items-center justify-between gap-[0.5rem] px-[1rem] py-[0.75rem]">
    <div class="font-[600] text-[0.875rem] leading-[150%] text-(--p-gray-950) md:flex-1">{{title()}}</div>

    <div class="flex items-center gap-[1.25rem]">
      @let imgRotated = isDirty();

      @if (imgRotated) {
        <div class="flex items-center gap-[0.5rem]">
          <p-button
            [label]="'@@shared-cancel__text' | translate"
            styleClass="!p-[0.375rem_1rem_0.5rem_1rem] text-[0.75rem] font-[600]"
            [outlined]="true"
            (onClick)="onCancel()" />
  
          <p-button
            [label]="'@@shared-save' | translate"
            styleClass="!p-[0.375rem_1rem_0.5rem_1rem] text-[0.75rem] font-[600]"
            (onClick)="onSave()" />
        </div>
      }

      <div class="flex items-center gap-[0.5rem]">
        <p-button
          [text]="true"
          severity="contrast"
          styleClass="!h-[1.75rem] !px-[0.1875rem] !py-[0.1875rem] !gap-[0.25rem] !text-(--p-primary-500) hover:!bg-(--p-neutral-500) hover:!border-(--p-primary-100)"
          [pTooltip]="'@@picture-galery-slider-rotate-left' | translate"
          (click)="onRotate(-1)"
          tooltipPosition="bottom"
          tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
          <svg-icon src="icons/icon-rotate-left.svg" class="text-(--p-primary-500)" name="icon-rotate-left"></svg-icon>
        </p-button>

        <div class="h-[1.75rem] bg-(--p-primary-50) w-[1px]"></div>
  
        <p-button
          [text]="true"
          severity="contrast"
          styleClass="!h-[1.75rem] !px-[0.1875rem] !py-[0.1875rem] !gap-[0.25rem] !text-(--p-primary-500) hover:!bg-(--p-neutral-500) hover:!border-(--p-primary-100)"
          [pTooltip]="'@@picture-galery-slider-rotate-right' | translate"
          (click)="onRotate(1)"
          tooltipPosition="bottom"
          tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
          <svg-icon src="icons/icon-rotate-right.svg" class="text-(--p-primary-500)" name="icon-rotate-right"></svg-icon>
        </p-button>

      </div>

      <p-button
        icon="true"
        severity="contrast"
        rounded="true"
        styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
        [text]="true"
        (click)="onClose()">
        <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
      </p-button>
    </div>
  </header>

  <div class="relative w-full max-w-full max-h-full flex-1 min-h-0 flex items-center justify-center overflow-hidden px-0">
    @if (showLoading()) {
      <div class="absolute inset-0 z-content-overlay-20">
        <gc-spinner></gc-spinner>
      </div>
    }

    <p-button
      styleClass="!p-[0.5625rem] font-[600] !absolute !left-[1rem] !top-1/2 !-translate-y-1/2 !z-content-overlay-10"
      [disabled]="!hasPrevious()"
      (onClick)="onPrevious()">
      <svg-icon src="icons/icon-arrow-left.svg" name="icon-arrow-left"></svg-icon>
    </p-button>

    <div
      #track
      class="flex h-full w-full will-change-transform"
      [style.transform]="trackTransform()"
      [style.transition]="trackTransition()"
      (transitionend)="onTrackTransitionEnd($event)"
      gcPan
      (panStart)="onPanStart()"
      (panMove)="onPanMove($event)"
      (panEnd)="onPanEnd($event)">
      @for (slide of slides(); track slide.key) {
        <div
          class="shrink-0 grow-0 basis-full h-full flex items-center justify-center overflow-hidden will-change-transform"
          [style.opacity]="slide.opacity"
          [style.transform]="'scale(' + slide.scale + ')'"
          [style.transition]="slideTransition()">
          @if (slide.picture) {
            <div
              class="relative flex flex-row justify-center max-w-full max-h-full items-center overflow-hidden"
              [gcPictureRotationSize]="slide.picture">
              <img
                [src]="slide.imageUrl"
                [alt]="slide.imageUrl"
                class="object-cover pointer-events-none select-none"
                draggable="false"
                [style.transform]="'rotate(' + slide.rotation + 'deg)'" />

              <div
                class="absolute inset-x-0 left-0 bottom-0 w-full pt-[1.5rem] pb-[1.25rem]"
                style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);">
                <div class="font-[500] text-[0.6875rem] leading-[150%] tracking-[0%] text-center text-(--p-white)">
                  {{ slide.date }}
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <p-button
      styleClass="!p-[0.5625rem] !absolute !right-[1rem] !top-1/2 !-translate-y-1/2 !z-content-overlay-10"
      [disabled]="!hasNext()"
      (onClick)="onNext()">
      <svg-icon src="icons/icon-arrow-right.svg" name="icon-arrow-right"></svg-icon>
    </p-button>
  </div>

  <footer class="flex items-center justify-center gap-[1rem] pt-[1.1875rem] pb-[1.1875rem]">
    <div class="font-[600] text-[0.75rem] leading-[150%] text-center text-(--p-primary-500)">
      {{ currentIndex() + 1 }}/{{ pictures().length }}
    </div>
  </footer>
</div>
